import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { supabase } from "../utils/supabaseClient";

export default function Launch() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState("verifying");
  const [plan, setPlan] = useState(null); // <-- optional: show plan name

useEffect(() => {
  const continueVerification = async (session) => {
    try {
      const res = await fetch(
        `${"https://vintariai-backend-1.onrender.com"}/api/verify-checkout?session_id=${sessionId}`,
        {
          headers: {
            Authorization: `Bearer ${session.access_token}`,
          },
        }
      );

      const result = await res.json();

      if (result.paid) {
        setPlan(result.plan);
        await supabase.auth.refreshSession();
        setStatus("success");

        setTimeout(() => navigate("/strategist"), 2000);
      } else {
        setStatus("failed");
      }
    } catch (err) {
      console.error("❌ Verification error:", err);
      setStatus("error");
    }
  };

  const verifyPurchase = async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (!session) {
      const { data: userListener } = supabase.auth.onAuthStateChange(
        async (event, session) => {
          if (session) {
            await continueVerification(session);
            userListener.subscription.unsubscribe();
          } else {
            setStatus("unauthenticated");
          }
        }
      );

      setTimeout(() => {
        setStatus("unauthenticated");
        userListener.subscription.unsubscribe();
      }, 3000);

      return;
    }

    await continueVerification(session);
  };

  if (sessionId) verifyPurchase();
  else setStatus("missing");
}, [sessionId, navigate]);


useEffect(() => {
  if (status === "unauthenticated") {
    const timeout = setTimeout(() => {
      navigate("/login");
    }, 2000); // 2 second delay

    return () => clearTimeout(timeout); // Cleanup
  }
}, [status, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-indigo-900 via-purple-900 to-blue-900 text-white text-center px-6">
      {status === "verifying" && <p>🔄 Verifying your purchase...</p>}

      {status === "success" && (
        <>
          <p className="text-lg font-semibold mb-2">✅ Success!</p>
          <p className="mb-4">Your plan has been upgraded to <strong className="text-green-300 uppercase">{plan}</strong>.</p>
          <p>Redirecting you to the strategist...</p>
        </>
      )}

      {status === "failed" && <p>❌ Payment not completed. Please contact support.</p>}
      {status === "unauthenticated" && <p>🔒 Please log in to continue.</p>}
      {status === "missing" && <p>⚠️ No session ID provided.</p>}
      {status === "error" && <p>🚨 Something went wrong. Please try again.</p>}
    </div>
  );
}
